// src/App.jsx
import React, { useState } from 'react';
import MapComponent from './components/MapComponent';
import SearchDrawer from './components/SearchDrawer';
import { MapProvider } from './context/MapContext';
import { fromLonLat } from 'ol/proj';
import { Vector as VectorLayer } from 'ol/layer';
import { Vector as VectorSource } from 'ol/source';
import { Point } from 'ol/geom';
import { Feature } from 'ol';
import { Style, Icon } from 'ol/style';
import './style.css'
import { BrowserRouter as Router, Route,Routes } from 'react-router-dom';

const App = () => {
  const [drawerOpen, setDrawerOpen] = useState(true); // Default state: drawer is open
  const [searchQuery, setSearchQuery] = useState('');
  const [searchResults, setSearchResults] = useState([]);

  // Initialize vector layer for search results
  const vectorSource = new VectorSource();
  const vectorLayer = new VectorLayer({
    source: vectorSource,
  });

  const handleSearch = () => {
    // Simulated search result (replace with actual API)
    const mockResults = [
      { name: 'New York', coordinates: [-74.006, 40.7128] }, // Lon, Lat
      { name: 'Los Angeles', coordinates: [-118.2437, 34.0522] },
    ];

    const results = mockResults.filter((location) =>
      location.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setSearchResults(results);

    // Clear previous results from the map
    vectorSource.clear();

    // Add results to the map
    results.forEach((result) => {
      const [lon, lat] = result.coordinates;
      const feature = new Feature({
        geometry: new Point(fromLonLat([lon, lat])),
      });

      // Add a marker style to the feature
      feature.setStyle(
        new Style({
          image: new Icon({
            anchor: [0.5, 1],
            src: 'https://openlayers.org/en/v4.6.5/examples/data/icon.png', // Marker icon
          }),
        })
      );
      vectorSource.addFeature(feature);
    });

    // Zoom to the first result
    if (results.length > 0) {
      const [lon, lat] = results[0].coordinates;
      map.getView().animate({ center: fromLonLat([lon, lat]), zoom: 10 });
    }
  };

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  return (
    <MapProvider>
  <Router>
    <Routes>
      <Route path="/" element={<MapComponent />} />
      {/* Add other routes here */}
    </Routes>
  </Router>
</MapProvider>

  );
};

export default App;
